"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const material_1 = require("@mui/material");
const ArgusMenuItem_1 = tslib_1.__importDefault(require("./ArgusMenuItem"));
const ArgusHoverMenu = (props) => {
    const { children, menuItems = [], openMenu } = props;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const handleMouseEnter = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleMouseLeave = () => {
        setAnchorEl(null);
    };
    /**
     * We don't want to trigger the popper if the menu is on the `open` state.
     */
    const isHovered = Boolean(anchorEl) && !openMenu;
    return (react_1.default.createElement("div", { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        children,
        react_1.default.createElement(material_1.Popper, { sx: { zIndex: (theme) => theme.zIndex.modal }, anchorEl: anchorEl, open: isHovered, placement: "right-start" },
            react_1.default.createElement(material_1.Paper, { elevation: 0, sx: {
                    bgcolor: "common.black",
                    marginLeft: 2,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                } },
                react_1.default.createElement(material_1.List, null, menuItems.map((item) => (react_1.default.createElement(ArgusMenuItem_1.default, { open: isHovered, key: item.label, hideIcon: true, ListItemTextProps: { sx: { paddingLeft: 0, paddingRight: 2 } }, ...item }))))))));
};
exports.default = ArgusHoverMenu;
